module.exports = __webpack_public_path__ + "img/full1-min.6792bcf9.png";